import React from 'react';
import './google-review-icon.css';

const GoogleReviewIcon = () => {
  return (
    <div className="review-card">
      <div className="review-content">
        <div className="google-logo">
          <span className="g">G</span>
          <span className="o1">o</span>
          <span className="o2">o</span>
          <span className="g2">g</span>
          <span className="l">l</span>
          <span className="e">e</span>
        </div>
        
        <div className="stars">
          <span className="star">★</span>
          <span className="star">★</span>
          <span className="star">★</span>
          <span className="star">★</span>
          <span className="star">★</span>
        </div>
      </div>
    </div>
  );
};

export default GoogleReviewIcon;